import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import Seo from "../components/Seo";
import Reveal from "../components/Reveal";
import ContactForm from "../components/ContactForm";

const GUARANTEES = ["Valutazione gratuita", "Risposta entro 24 ore", "Nessun impegno"];

export default function RichiediValutazione() {
  return (
    <>
      <Seo
        title="Richiedi una valutazione gratuita"
        description="Descrivi la tua pratica: la prima valutazione è gratuita e senza impegno, risposta entro 24 ore. DN STUDIO TECNICO opera in tutta Italia."
        path="/richiedi-valutazione"
      />
      <section className="bg-paper pb-10 pt-14 lg:pb-14 lg:pt-20" data-testid="page-richiedi-valutazione">
        <div className="container-site">
          <Reveal>
            <p className="eyebrow">Richiedi una valutazione</p>
            <h1 className="mt-4 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-antracite sm:text-4xl lg:text-5xl">
              Descrivici la tua pratica
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted">
              La prima valutazione è gratuita e senza impegno. Ti rispondiamo entro 24 ore.
            </p>
            <ul className="mt-7 flex flex-wrap gap-2.5">
              {GUARANTEES.map((g) => (
                <li
                  key={g}
                  className="inline-flex items-center gap-2 rounded-full border border-line bg-white px-4 py-2 text-xs font-medium text-antracite-soft"
                  data-testid="guarantee-chip"
                >
                  <Check size={13} strokeWidth={2.5} className="text-petrolio" />
                  {g}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-site">
          <div className="mx-auto max-w-3xl rounded-3xl border border-line bg-white p-6 shadow-[0_4px_30px_rgba(23,63,58,0.05)] sm:p-10">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
